<template>
    <div class="affirm pointer" @click="showModal">
        <span
            class="affirm-as-low-as"
            :data-amount="amount"
            :data-affirm-color="color"
            data-page-type="payment"
        />
    </div>
</template>

<script>
const BUBBLING_PHASE = 3;

import { gtmTrack } from "@/util/gtm";

export default {
    name: "Affirm",
    props: {
        color: {
            type: String,
            default: "white"
        },
        price: {
            type: [String, Number],
            default: 0
        }
    },
    data() {
        return {
            amount: 0,
            clickedPhase: 0
        }
    },
    watch: {
        amount() {
            this.refresh();
        },
        price() {
            this.affirmPrice();
        }
    },
    created() {
        this.affirmPrice();
    },
    methods: {
        affirmPrice() {
            this.amount = window.accounting.format(this.price, 2).toString().replace(/[.,]/g, "");
        },
        refresh() {
            setTimeout(() => {
                window.affirm.ui.refresh();
            }, 25)
        },
        showModal(e) {
            this.$el.querySelector(".affirm-modal-trigger").click();
            const isOriginalTrigger = e.target.className.includes("affirm-modal-trigger");
            this.clickedPhase = BUBBLING_PHASE == this.clickedPhase ? 0 : e.eventPhase;

            if (BUBBLING_PHASE == this.clickedPhase && isOriginalTrigger) {
                gtmTrack.financeInquires();
                this.$emit("click");
            }
        }
    }
}
</script>

<style lang="scss">
@import "~@s/_asset-mixers.scss";

.affirm {
    text-transform: initial;

    a {
        color: $orchid;
    }
}
</style>
